import React from 'react';
import 'rsuite/dist/styles/rsuite-default.css';
///* rsuiteのモーダルを画面全面に表示するための設定追加
import './index.css';

import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import {  BrowserRouter, Routes, Navigate, Route} from 'react-router-dom';
import AdministratorsPage from './components/pages/Administrators';
import PrivateRoute from './utils/PrivateRoute';
import PublicRoute from './utils/PublicRoute';
import ChallengesPage from './components/pages/Challenges';
import DashBoardPage from './components/pages/DashBoard';
import GroupPage from './components/pages/Groups';
import HealthChecksPage from './components/pages/HealthChecks';
import LoginPage from './components/pages/Login';
import UserDetailPage from './components/pages/UserDetail';
import UsersPage from './components/pages/Users';
import ResetPasswordPage from './components/pages/ResetPassword';
import GroupBattlePage from './components/pages/GroupBattle/GroupBattles';
import GroupBattleDetailPage from './components/pages/GroupBattle/GroupBattleDetail';
import TalkgroupPage from './components/pages/Chatgroups/Chatgroups';
import TalkgroupListPage from './components/pages/Chatgroups/ChatgroupsList';
import CommonContext from './utils/CommonContext';
import Import from './components/pages/Import';
import LoginManagement from './components/pages/LoginManagement';
import CompanyBattles from './components/pages/CompanyBattle/CompanyBattle';
import CompanyBattleDetail from './components/pages/CompanyBattle/CompanyBattleDetail';

const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <CommonContext>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={ <PublicRoute><LoginPage /></PublicRoute>} />
            <Route path="/reset_password" element={ <PublicRoute><ResetPasswordPage /></PublicRoute>} />
            <Route path="/dashboard" element={ <PrivateRoute><DashBoardPage /></PrivateRoute>} />
            <Route path="/administrators" element={ <PrivateRoute><AdministratorsPage /></PrivateRoute>} />
            <Route path="/challenges" element={ <PrivateRoute><ChallengesPage /></PrivateRoute>} />
            <Route path="/groups" element={ <PrivateRoute><GroupPage /></PrivateRoute>} />
            <Route path="/healthchecks" element={ <PrivateRoute><HealthChecksPage /></PrivateRoute>} />
            <Route path="/users" element={ <PrivateRoute><UsersPage /></PrivateRoute>} />
            <Route path="/userdetail" element={ <PrivateRoute><UserDetailPage /></PrivateRoute>} />
            <Route path="/import" element={ <PrivateRoute><Import /></PrivateRoute>} />
            <Route path="/login_management/:login_date" element={ <PrivateRoute><LoginManagement /></PrivateRoute>} />
            <Route path="/groupbattles" element={ <PrivateRoute><GroupBattlePage /></PrivateRoute>} />
            <Route path="/chatgroups" element={ <PrivateRoute><TalkgroupPage /></PrivateRoute>} />
            <Route path="/chatgroupsList" element={ <PrivateRoute><TalkgroupListPage /></PrivateRoute>} />
            <Route path="/groupbattledetail/:groupbattleid" element={ <PrivateRoute><GroupBattleDetailPage /></PrivateRoute>} />
            <Route path="/companybattles" element={ <PrivateRoute><CompanyBattles /></PrivateRoute>} />
            <Route path="/companybattledetail/:companybattleid" element={ <PrivateRoute><CompanyBattleDetail /></PrivateRoute>} />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
          {/* TODO  ログインしている時に任意のパス/aaaなどに飛んだ時の制御*/}
        </BrowserRouter>
      </CommonContext>
      <ReactQueryDevtools initialIsOpen />
    </QueryClientProvider>
  );
};

export default App;
